import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAuth, User } from "firebase/auth";

export interface UserState {
  user: User | undefined;
  isAuthenticated: boolean;
}

const initialState: UserState = {
    isAuthenticated: getAuth().currentUser ? true : false,
    user: getAuth().currentUser || {} as User,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuthentication(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    }
  },
});

export const { setAuthentication, setUser } = userSlice.actions;
export default userSlice.reducer;
